import { FC, useState } from "react";
import { FormControl, IconButton, Select, Stack } from "@contentful/f36-components";
import { HelpCircleIcon } from "@contentful/f36-icons";
import tokens from "@contentful/f36-tokens";
import { formalityOptions, isFormalityEnabled } from "../lib";
import { FormalityHelpModal } from "./";

interface FormalitySelectProps {
    value: string;
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    isInSidebar?: boolean;
}

export const FormalitySelect: FC<FormalitySelectProps> = ({ value, onChange, isInSidebar }) => {
    const [isHelpModalShown, setHelpModalShown] = useState(false);

    if (!isFormalityEnabled) {
        return null;
    }

    return (
        <FormControl marginBottom="none">
            {isInSidebar ? (
                <FormControl.Label style={{ color: tokens.purple500 }}>Formality</FormControl.Label>
            ) : (
                <Stack justifyContent="space-between" alignItems="center">
                    <FormControl.Label style={{ color: tokens.purple500 }} marginBottom="none">
                        Formality
                    </FormControl.Label>
                    <IconButton
                        aria-label="Learn more about formality in Linguiny"
                        icon={<HelpCircleIcon variant="premium" />}
                        onClick={() => setHelpModalShown(true)}
                    />
                    <FormalityHelpModal
                        isShown={isHelpModalShown}
                        onClose={() => setHelpModalShown(false)}
                    />
                </Stack>
            )}
            <Select value={value} onChange={onChange}>
                {formalityOptions.map(option => (
                    <Select.Option key={option.key} value={option.key}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
        </FormControl>
    );
};
